export const isStoreImageBackground = (background: string) => background.includes('http');

export const isBackgroundNotSelected = (background: string) => background === 'white';
